import { Identificator } from './custom-types';

export class KontoBankowe {
  id?: Identificator | null;
  numerKonta!: string | null;
  czyZagraniczne!: boolean | null;
  daneBanku!: string | null;
  identyfikatorBanku!: string | null;
  nieJestWlascicielem!: boolean | null;
  daneWlasciciela!: string | null;
}
